export default Object.freeze({
  CLOSED: 'closed',
  OPEN: 'open',
  UPCOMING: 'upcoming',
});
